var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 91,
    viewBox: "0 0 90 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2429_2275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45 7.5C24.3 7.5 7.5 24.3 7.5 45C7.5 65.7 24.3 82.5 45 82.5C65.7 82.5 82.5 65.7 82.5 45C82.5 24.3 65.7 7.5 45 7.5ZM62.4 33C61.8375 38.925 59.4 53.325 58.1625 59.9625C57.6375 62.775 56.5875 63.7125 55.6125 63.825C53.4375 64.0125 51.7875 62.4 49.6875 61.0125C46.3875 58.8375 44.5125 57.4875 41.325 55.3875C37.6125 52.95 40.0125 51.6 42.15 49.425C42.7125 48.8625 52.3125 40.125 52.5 39.3375C52.5261 39.2182 52.5226 39.0944 52.4899 38.9768C52.4572 38.8591 52.3963 38.7513 52.3125 38.6625C52.0875 38.475 51.7875 38.55 51.525 38.5875C51.1875 38.6625 45.9375 42.15 35.7 49.05C34.2 50.0625 32.85 50.5875 31.65 50.55C30.3 50.5125 27.75 49.8 25.8375 49.1625C23.475 48.4125 21.6375 48 21.7875 46.6875C21.8625 46.0125 22.8 45.3375 24.5625 44.625C35.5125 39.8625 42.7875 36.7125 46.425 35.2125C56.85 30.8625 58.9875 30.1125 60.4125 30.1125C60.7125 30.1125 61.425 30.1875 61.875 30.5625C62.25 30.8625 62.3625 31.275 62.4 31.575C62.3625 31.8 62.4375 32.475 62.4 33Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2429_2275",
    x: -4,
    y: 0,
    width: 98,
    height: 98,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2429_2275"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2429_2275",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.c3a363532b9fb3d9e8c606d693f01722.svg";
export { ForwardRef as ReactComponent };